import Axios from 'axios';
import qs from 'qs';
import ui from '../ducks/ui/actions.js';
import { logout } from '../ducks/auth/operations.js';
import { getToken, getBaseURL } from '../ducks/auth/selectors.js';


const axios = Axios.create({
    // support queryParams with duplicate names (ex: 'a[0]=b&a[1]=c&a[2]=d')
    paramsSerializer: params => qs.stringify(params, { indices: false }),
});


const apiMiddleware = store => next => async (action) => {
    const { type, payload } = action;
    const { getState, dispatch } = store;


    if (!type.startsWith('API/')) {
        return next(action);
    }

    const state = getState();
    const access_token = getToken(state);

    if (access_token && payload.url !== '/oauth/token') {
        payload.params = { access_token, ...payload.params };
    }

    const config = {
        baseURL: getBaseURL(state),
        ...payload,
    };

    // pass action to next middlewear. mostly for showing the dispatch on devTool
    next(action);

    try {
        const res = await axios(config);
        return res;

    } catch (error) {
        if (error.response) {
            /*
                The request was made and the server responded with a status code
                that falls out of the range of 2xx
            */
            if (error.response.status === 401) {
                // Unauthorized
                logout()(dispatch);
                dispatch(ui.flash.warn({ header: 'Login Expired', content: 'Please login again' }));
            }
        } else if (error.request) {
            /*
                The request was made but no response was received
                `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                http.ClientRequest in node.js
            */
            dispatch(ui.flash.error({ header: 'Network Failure', content: 'API server not available' }));
        } else {
            // Something happened in setting up the request that triggered an Error
            dispatch(ui.flash.error({ header: 'Error', content: error.message }));
        }

        throw error;
    }
};

export default apiMiddleware;
